module.exports = __webpack_public_path__ + "static/media/soy.f7135d66.svg";